import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import WhatsAppButton from "@/components/WhatsAppButton";
import { api } from "@/lib/api";
import { Briefcase, ArrowRight } from "lucide-react";

export default function InternshipsPublic() {
  const [items, setItems] = useState([]);
  const [hp, setHp] = useState(null);
  useEffect(() => {
    api.get("/public/internships").then((r) => setItems(r.data || [])).catch(() => {});
    api.get("/public/homepage").then((r) => setHp(r.data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <section className="bg-slate-50 border-b border-slate-200 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#F59E0B]">Internships</div>
          <h1 className="heading mt-3 text-4xl sm:text-5xl font-bold">Learn. Contribute. Earn a certificate.</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {items.length === 0 ? (
          <div className="p-14 rounded-2xl border border-dashed border-slate-300 text-center">
            <Briefcase size={40} className="mx-auto text-slate-300" />
            <div className="mt-4 text-slate-500">New programs launching soon.</div>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((i) => (
              <div key={i.id} className="p-6 rounded-2xl border border-slate-200 hover:-translate-y-1 hover:shadow-lg transition bg-white">
                <div className="text-[11px] uppercase tracking-[0.2em] text-[#F59E0B] font-bold">{i.duration}</div>
                <h3 className="heading text-xl font-bold mt-2">{i.title}</h3>
                <p className="mt-2 text-sm text-slate-600 line-clamp-4">{i.description}</p>
                {i.skills && <div className="mt-3 text-xs text-slate-500">Skills: {i.skills}</div>}
                <Link to="/login" className="mt-4 inline-flex items-center gap-1 text-brand font-semibold text-sm">
                  Login to apply <ArrowRight size={14} />
                </Link>
              </div>
            ))}
          </div>
        )}
      </section>
      <PublicFooter contact={hp} />
      <WhatsAppButton number={hp?.whatsapp_number} />
    </div>
  );
}
